module.exports = __webpack_public_path__ + "static/media/1.9a8c4149.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9019/1.jpg
// module id = 867
// module chunks = 0